import { styled } from '@mui/system';
import { Stack } from '@mui/material';

export const ButtonContainer = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),
    width: '428px',
}));
